export default [
  {
    path: '/apps/calendar',
    name: 'apps-calendar',
    component: () => import('@/views/apps/calendar/Calendar.vue'),
  },

  // *===============================================---*
  // *--------- EMAIL & IT'S FILTERS N LABELS -------------------------------*
  // *===============================================---*
  {
    path: '/apps/email',
    name: 'apps-email',
    component: () => import('@/views/apps/email/Email.vue'),
    meta: {
      contentRenderer: 'sidebar-left',
      contentClass: 'email-application',
    },
  },
  {
    path: '/apps/email/:folder',
    name: 'apps-email-folder',
    component: () => import('@/views/apps/email/Email.vue'),
    meta: {
      contentRenderer: 'sidebar-left',
      contentClass: 'email-application',
      navActiveLink: 'apps-email',
    },
    beforeEnter(to, _, next) {
      if (['sent', 'draft', 'starred', 'spam', 'trash'].includes(to.params.folder)) next()
      else next({ name: 'error-404' })
    },
  },
  {
    path: '/apps/email/label/:label',
    name: 'apps-email-label',
    component: () => import('@/views/apps/email/Email.vue'),
    meta: {
      contentRenderer: 'sidebar-left',
      contentClass: 'email-application',
      navActiveLink: 'apps-email',
    },
    beforeEnter(to, _, next) {
      if (['personal', 'company', 'important', 'private'].includes(to.params.label)) next()
      else next({ name: 'error-404' })
    },
  },

  // *===============================================---*
  // *--------- TODO & IT'S FILTERS N TAGS ---------------------------------------*
  // *===============================================---*
  {
    path: '/apps/todo',
    name: 'apps-todo',
    component: () => import('@/views/apps/todo/Todo.vue'),
    meta: {
      contentRenderer: 'sidebar-left',
      contentClass: 'todo-application',
    },
  },
  {
    path: '/apps/todo/:filter',
    name: 'apps-todo-filter',
    component: () => import('@/views/apps/todo/Todo.vue'),
    meta: {
      contentRenderer: 'sidebar-left',
      contentClass: 'todo-application',
      navActiveLink: 'apps-todo',
    },
    beforeEnter(to, _, next) {
      if (['important', 'completed', 'deleted'].includes(to.params.filter)) next()
      else next({ name: 'error-404' })
    },
  },
  {
    path: '/apps/todo/tag/:tag',
    name: 'apps-todo-tag',
    component: () => import('@/views/apps/todo/Todo.vue'),
    meta: {
      contentRenderer: 'sidebar-left',
      contentClass: 'todo-application',
      navActiveLink: 'apps-todo',
    },
    beforeEnter(to, _, next) {
      if (['team', 'low', 'medium', 'high', 'update'].includes(to.params.tag)) next()
      else next({ name: 'error-404' })
    },
  },

  // *===============================================---*
  // *--------- CHAT  ---------------------------------------*
  // *===============================================---*
  {
    path: '/apps/chat',
    name: 'apps-chat',
    component: () => import('@/views/apps/chat/Chat.vue'),
    meta: {
      contentRenderer: 'sidebar-left',
      contentClass: 'chat-application',
    },
  },

  // *===============================================---*
  // *--------- ECOMMERCE  ---------------------------------------*
  // *===============================================---*
  {
    path: '/apps/e-commerce/shop',
    name: 'apps-e-commerce-shop',
    component: () => import('@/views/apps/e-commerce/e-commerce-shop/ECommerceShop.vue'),
    meta: {
      contentRenderer: 'sidebar-left-detached',
      contentClass: 'ecommerce-application',
      pageTitle: 'Shop',
      breadcrumb: [
        {
          text: 'ECommerce',
        },
        {
          text: 'Shop',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/e-commerce/wishlist',
    name: 'apps-e-commerce-wishlist',
    component: () => import('@/views/apps/e-commerce/e-commerce-wishlist/ECommerceWishlist.vue'),
    meta: {
      pageTitle: 'Wishlist',
      contentClass: 'ecommerce-application',
      breadcrumb: [
        {
          text: 'ECommerce',
        },
        {
          text: 'Wishlist',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/e-commerce/checkout',
    name: 'apps-e-commerce-checkout',
    component: () => import('@/views/apps/e-commerce/e-commerce-checkout/ECommerceCheckout.vue'),
    meta: {
      pageTitle: 'Checkout',
      contentClass: 'ecommerce-application',
      breadcrumb: [
        {
          text: 'ECommerce',
        },
        {
          text: 'Checkout',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/e-commerce/:slug',
    name: 'apps-e-commerce-product-details',
    component: () => import('@/views/apps/e-commerce/e-commerce-product-details/ECommerceProductDetails.vue'),
    meta: {
      pageTitle: 'Product Details',
      contentClass: 'ecommerce-application',
      breadcrumb: [
        {
          text: 'ECommerce',
        },
        {
          text: 'Shop',
          active: true,
        },
        {
          text: 'Product Details',
          active: true,
        },
      ],
    },
  },

  // *===============================================---*
  // *--------- USER ---- ---------------------------------------*
  // *===============================================---*
  {
    path: '/apps/users/list',
    name: 'apps-users-list',
    component: () => import('@/views/apps/user/users-list/UsersList.vue'),
  },
  {
    path: '/apps/users/view/:id',
    name: 'apps-users-view',
    component: () => import('@/views/apps/user/users-view/UsersView.vue'),
  },
  {
    path: '/apps/users/edit/:id',
    name: 'apps-users-edit',
    component: () => import('@/views/apps/user/users-edit/UsersEdit.vue'),
  },
  // *===============================================---*
  // *--------- CUSTOMER ---- ---------------------------------------*
  // *===============================================---*
   {
     path: '/apps/customer/list',
     name: 'apps-customer-list',
     component: () => import('@/views/apps/customer/list/List.vue'),
   },
   {
     path: '/apps/customer/add',
     name: 'apps-customer-add',
     component: () => import('@/views/apps/customer/add/Add.vue'),
   },
   {
     path: '/apps/customer/edit/:id',
     name: 'apps-customer-edit',
     component: () => import('@/views/apps/customer/edit/Edit.vue'),
   },

  // Invoice
  {
    path: '/apps/invoice/list',
    name: 'apps-invoice-list',
    component: () => import('@/views/apps/invoice/invoice-list/InvoiceList.vue'),
  },
  {
    path: '/apps/invoice/preview/:id',
    name: 'apps-invoice-preview',
    component: () => import('@/views/apps/invoice/invoice-preview/InvoicePreview.vue'),
  },
  {
    path: '/apps/invoice/add/',
    name: 'apps-invoice-add',
    component: () => import('@/views/apps/invoice/invoice-add/InvoiceAdd.vue'),
  },
  {
    path: '/apps/invoice/edit/:id',
    name: 'apps-invoice-edit',
    component: () => import('@/views/apps/invoice/invoice-edit/InvoiceEdit.vue'),
  },
    // *===============================================---*
    // *--------- Bank ---- ---------------------------------------*
    // *===============================================---*
    {
        path: '/apps/bank/list',
        name: 'apps-bank-list',
        component: () => import('@/views/apps/bank/list/List.vue'),
    },
    {
        path: '/apps/bank/add',
        name: 'apps-bank-add',
        component: () => import('@/views/apps/bank/edit/Edit.vue'),
    },
    {
        path: '/apps/bank/view/:id',
        name: 'apps-bank-view',
        component: () => import('@/views/apps/bank/view/View.vue'),
    },
    {
        path: '/apps/bank/edit/:id',
        name: 'apps-bank-edit',
        component: () => import('@/views/apps/bank/edit/Edit.vue'),
    },
    // *===============================================---*
    // *--------- Warehouse ---- ---------------------------------------*
    // *===============================================---*
    {
        path: '/apps/warehouse/list',
        name: 'apps-warehouse-list',
        component: () => import('@/views/apps/warehouse/list/List.vue'),
    },
    {
        path: '/apps/warehouse/add',
        name: 'apps-warehouse-add',
        component: () => import('@/views/apps/warehouse/edit/Edit.vue'),
    },
    {
        path: '/apps/warehouse/view/:id',
        name: 'apps-warehouse-view',
        component: () => import('@/views/apps/warehouse/view/View.vue'),
    },
    {
        path: '/apps/warehouse/edit/:id',
        name: 'apps-warehouse-edit',
        component: () => import('@/views/apps/warehouse/edit/Edit.vue'),
    },
    // *===============================================---*
    // *--------- Country ---- ---------------------------------------*
    // *===============================================---*
    {
        path: '/apps/country/list',
        name: 'apps-country-list',
        component: () => import('@/views/apps/country/list/List.vue'),
    },
    {
        path: '/apps/country/add',
        name: 'apps-country-add',
        component: () => import('@/views/apps/country/edit/Edit.vue'),
    },
    {
        path: '/apps/country/view/:id',
        name: 'apps-country-view',
        component: () => import('@/views/apps/country/view/View.vue'),
    },
    {
        path: '/apps/country/edit/:id',
        name: 'apps-country-edit',
        component: () => import('@/views/apps/country/edit/Edit.vue'),
    },
    // *===============================================---*
    // *--------- City ---- ---------------------------------------*
    // *===============================================---*
    {
        path: '/apps/city/list',
        name: 'apps-city-list',
        component: () => import('@/views/apps/city/list/List.vue'),
    },
    {
        path: '/apps/city/add',
        name: 'apps-city-add',
        component: () => import('@/views/apps/city/edit/Edit.vue'),
    },
    {
        path: '/apps/city/view/:id',
        name: 'apps-city-view',
        component: () => import('@/views/apps/city/view/View.vue'),
    },
    {
        path: '/apps/city/edit/:id',
        name: 'apps-city-edit',
        component: () => import('@/views/apps/city/edit/Edit.vue'),
    },
    // *===============================================---*
    // *--------- Stocks ---- ---------------------------------------*
    // *===============================================---*
    {
        path: '/apps/stock/list',
        name: 'apps-stock-list',
        component: () => import('@/views/apps/stock/list/List.vue'),
    },
    {
        path: '/apps/stock/add',
        name: 'apps-stock-add',
        component: () => import('@/views/apps/stock/edit/Edit.vue'),
    },
    {
        path: '/apps/stock/view/:id',
        name: 'apps-stock-view',
        component: () => import('@/views/apps/stock/view/View.vue'),
    },
    {
        path: '/apps/stock/edit/:id',
        name: 'apps-stock-edit',
        component: () => import('@/views/apps/stock/edit/Edit.vue'),
    },
    // *===============================================---*
    // *--------- Barcodes ---- ---------------------------------------*
    // *===============================================---*
    {
        path: '/apps/barcode/list',
        name: 'apps-barcode-list',
        component: () => import('@/views/apps/barcode/list/List.vue'),
    },
    {
        path: '/apps/barcode/add',
        name: 'apps-barcode-add',
        component: () => import('@/views/apps/barcode/edit/Edit.vue'),
    },
    {
        path: '/apps/barcode/view/:id',
        name: 'apps-barcode-view',
        component: () => import('@/views/apps/barcode/view/View.vue'),
    },
    {
        path: '/apps/barcode/edit/:id',
        name: 'apps-barcode-edit',
        component: () => import('@/views/apps/barcode/edit/Edit.vue'),
    },
]
